import React from "react";
import ReturnText$ from "@deosite/components-new/ReturnText";

const ReturnText = props => <ReturnText$ {...props} />;

export default ReturnText;
